<template>
  <div class="home" id="home">
    <div
      id="one-page-content"
      :class="splashOpen ? 'hide-tail' : ''"
      class="container-fluid px-0"
    >
      <div
        id="fade-screen"
        :style="{
          backgroundColor: fadeColor,
          opacity: 0,
          display: transitionRunning ? 'block' : 'none',
        }"
      ></div>
      <div
        id="modal-circle"
        v-show="!isDesignOpen && !isWebOpen"
        :class="`${isWebClicked ? 'web' : isDesignClicked ? 'design' : ''} ${
          isClosingModalAnim ? 'out' : ''
        }`"
        :style="{
          bottom: modalCircleCoordinates.bottom,
          left: modalCircleCoordinates.left,
        }"
      ></div>
      <Header
        v-if="!isFormOpen"
        :isDarkHeader="darkHeader"
        :currentSection="currentSection"
        @sectionClick="onHeaderSectionClick"
        @onOpenMenu="isMenuOpen = true"
        @onCloseMenu="isMenuOpen = false"
      />
      <div class="container-snapping">
        <!-- -------------------------------------------------------------------------- -->
        <!--                               HOME SECTION                                -->
        <!-- -------------------------------------------------------------------------- -->
        <section id="title">
          <div class="uno">
            <div class="big-title">
              <h1>LOREM IPSUM</h1>
              <h1>AGENCY</h1>
            </div>
          </div>
        </section>

        <!-- -------------------------------------------------------------------------- -->
        <!--                               FLOATING CIRCLE                              -->
        <!-- -------------------------------------------------------------------------- -->

        <div class="circle-container">
          <svg
            class="rotating"
            width="1077"
            height="1076"
            viewBox="0 0 1077 1076"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M538.469 1075.49C835.304 1075.49 1075.94 834.845 1075.94 537.995C1075.94 241.145 835.304 0.500122 538.469 0.500122C241.633 0.500122 1 241.145 1 537.995C1 834.845 241.633 1075.49 538.469 1075.49Z"
              stroke="white"
              stroke-miterlimit="10"
            />

            <path
              @click="onWhoWeAreClick"
              class="big who-we-are"
              d="M102.316 246.636C117.403 246.636 129.633 234.405 129.633 219.318C129.633 204.231 117.403 192 102.316 192C87.23 192 75 204.231 75 219.318C75 234.405 87.23 246.636 102.316 246.636Z"
              fill="white"
            />
            <path
              class="scritta"
              d="M153.82 230H154.588L156.76 222.668L158.932 230H159.7L162.268 221.6H161.596L159.328 229.148L157.12 221.6H156.46L154.192 229.148L151.948 221.6H151.264L153.82 230ZM163.395 230H164.043V226.016H168.903V230H169.551V221.6H168.903V225.416H164.043V221.6H163.395V230ZM178.83 225.8C178.83 223.316 177.222 221.528 174.906 221.528C172.602 221.528 170.982 223.316 170.982 225.8C170.982 228.284 172.602 230.072 174.906 230.072C177.222 230.072 178.83 228.284 178.83 225.8ZM171.654 225.8C171.654 223.652 172.986 222.128 174.906 222.128C176.838 222.128 178.17 223.652 178.17 225.8C178.17 227.948 176.838 229.472 174.906 229.472C172.986 229.472 171.654 227.948 171.654 225.8ZM185.461 230H186.229L188.401 222.668L190.573 230H191.341L193.909 221.6H193.237L190.969 229.148L188.761 221.6H188.101L185.833 229.148L183.589 221.6H182.905L185.461 230ZM195.036 230H200.364V229.4H195.684V226.004H199.476V225.404H195.684V222.2H200.208V221.6H195.036V230ZM204.833 230L205.841 227.432H209.705L210.713 230H211.409L208.169 221.6H207.413L204.161 230H204.833ZM207.773 222.32L209.513 226.832H206.033L207.773 222.32ZM212.473 230H213.121V226.496H215.533L217.513 230H218.245L216.205 226.376C217.441 226.184 218.221 225.284 218.221 224.048C218.221 222.56 217.177 221.6 215.581 221.6H212.473V230ZM215.545 222.2C216.781 222.2 217.561 222.92 217.561 224.048C217.561 225.164 216.769 225.896 215.533 225.896H213.121V222.2H215.545ZM219.61 230H224.938V229.4H220.258V226.004H224.05V225.404H220.258V222.2H224.782V221.6H219.61V230Z"
              fill="white"
            />
            <path
              d="M1064.5 701C1064.5 709.008 1058.01 715.5 1050 715.5C1041.99 715.5 1035.5 709.008 1035.5 701C1035.5 692.992 1041.99 686.5 1050 686.5C1058.01 686.5 1064.5 692.992 1064.5 701Z"
              fill="white"
              stroke="white"
            />
            <path
              class="scritta"
              d="M921.552 697.42C921.636 699.004 922.788 700.072 924.672 700.072C926.436 700.072 927.6 699.112 927.6 697.696C927.6 696.1 926.184 695.692 924.792 695.452C923.508 695.236 922.392 695.02 922.392 693.82C922.392 692.728 923.244 692.116 924.564 692.116C925.824 692.116 926.688 692.824 926.832 693.916H927.492C927.372 692.476 926.28 691.528 924.564 691.528C922.86 691.528 921.744 692.428 921.744 693.856C921.744 695.452 923.112 695.812 924.456 696.04C925.776 696.268 926.952 696.532 926.952 697.756C926.952 698.836 926.04 699.484 924.684 699.484C923.268 699.484 922.308 698.668 922.224 697.42H921.552ZM932.576 700.072C934.376 700.072 935.648 699.1 936.008 697.408H935.324C934.964 698.752 933.992 699.472 932.564 699.472C930.62 699.472 929.396 697.948 929.396 695.8C929.396 693.652 930.644 692.128 932.588 692.128C933.992 692.128 934.976 692.86 935.348 694.18H936.032C935.66 692.5 934.388 691.528 932.624 691.528C930.26 691.528 928.724 693.28 928.724 695.8C928.724 698.344 930.224 700.072 932.576 700.072ZM937.403 700H938.051V696.496H940.463L942.443 700H943.175L941.135 696.376C942.371 696.184 943.151 695.284 943.151 694.048C943.151 692.56 942.107 691.6 940.511 691.6H937.403V700ZM940.475 692.2C941.711 692.2 942.491 692.92 942.491 694.048C942.491 695.164 941.699 695.896 940.463 695.896H938.051V692.2H940.475ZM951.982 695.8C951.982 693.316 950.374 691.528 948.058 691.528C945.754 691.528 944.134 693.316 944.134 695.8C944.134 698.284 945.754 700.072 948.058 700.072C950.374 700.072 951.982 698.284 951.982 695.8ZM944.806 695.8C944.806 693.652 946.138 692.128 948.058 692.128C949.99 692.128 951.322 693.652 951.322 695.8C951.322 697.948 949.99 699.472 948.058 699.472C946.138 699.472 944.806 697.948 944.806 695.8ZM958.091 700V699.4H954.071V691.6H953.423V700H958.091ZM963.868 700V699.4H959.848V691.6H959.2V700H963.868ZM967.588 692.2H970.468V700H971.116V692.2H973.996V691.6H967.588V692.2ZM982.017 695.8C982.017 693.316 980.409 691.528 978.093 691.528C975.789 691.528 974.169 693.316 974.169 695.8C974.169 698.284 975.789 700.072 978.093 700.072C980.409 700.072 982.017 698.284 982.017 695.8ZM974.841 695.8C974.841 693.652 976.173 692.128 978.093 692.128C980.025 692.128 981.357 693.652 981.357 695.8C981.357 697.948 980.025 699.472 978.093 699.472C976.173 699.472 974.841 697.948 974.841 695.8ZM921.864 714H922.512V711.804L924.42 709.62L927.444 714H928.224L924.9 709.128L927.948 705.6H927.156L922.512 710.892V705.6H921.864V714ZM929.824 714V706.776L934.792 714H935.404V705.6H934.768V712.824L929.8 705.6H929.188V714H929.824ZM944.682 709.8C944.682 707.316 943.074 705.528 940.758 705.528C938.454 705.528 936.834 707.316 936.834 709.8C936.834 712.284 938.454 714.072 940.758 714.072C943.074 714.072 944.682 712.284 944.682 709.8ZM937.506 709.8C937.506 707.652 938.838 706.128 940.758 706.128C942.69 706.128 944.022 707.652 944.022 709.8C944.022 711.948 942.69 713.472 940.758 713.472C938.838 713.472 937.506 711.948 937.506 709.8ZM947.715 714H948.483L950.655 706.668L952.827 714H953.595L956.163 705.6H955.491L953.223 713.148L951.015 705.6H950.355L948.087 713.148L945.843 705.6H945.159L947.715 714ZM960.524 714H961.16V706.692L964.304 714H964.892L968.036 706.692V714H968.672V705.6H967.856L964.616 713.124L961.352 705.6H960.524V714ZM977.951 709.8C977.951 707.316 976.343 705.528 974.027 705.528C971.723 705.528 970.103 707.316 970.103 709.8C970.103 712.284 971.723 714.072 974.027 714.072C976.343 714.072 977.951 712.284 977.951 709.8ZM970.775 709.8C970.775 707.652 972.107 706.128 974.027 706.128C975.959 706.128 977.291 707.652 977.291 709.8C977.291 711.948 975.959 713.472 974.027 713.472C972.107 713.472 970.775 711.948 970.775 709.8ZM979.391 714H980.039V710.496H982.451L984.431 714H985.163L983.123 710.376C984.359 710.184 985.139 709.284 985.139 708.048C985.139 706.56 984.095 705.6 982.499 705.6H979.391V714ZM982.463 706.2C983.699 706.2 984.479 706.92 984.479 708.048C984.479 709.164 983.687 709.896 982.451 709.896H980.039V706.2H982.463ZM986.528 714H991.856V713.4H987.176V710.004H990.968V709.404H987.176V706.2H991.7V705.6H986.528V714Z"
              fill="white"
            />
          </svg>

          <div class="rotating-mobile-ctn">
            <svg
              class="rotating-mobile"
              width="1077"
              height="1076"
              viewBox="0 0 1077 1076"
              fill="none"
              stroke="white"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M538.469 1075.49C835.304 1075.49 1075.94 834.845 1075.94 537.995C1075.94 241.145 835.304 0.500122 538.469 0.500122C241.633 0.500122 1 241.145 1 537.995C1 834.845 241.633 1075.49 538.469 1075.49Z"
                stroke="white"
                stroke-miterlimit="10"
              />

              <path
                @click="onWhoWeAreClick"
                class="big who-we-are"
                d="M102.316 246.636C117.403 246.636 129.633 234.405 129.633 219.318C129.633 204.231 117.403 192 102.316 192C87.23 192 75 204.231 75 219.318C75 234.405 87.23 246.636 102.316 246.636Z"
                fill="white"
              />
              <path
                d="M1064.5 701C1064.5 709.008 1058.01 715.5 1050 715.5C1041.99 715.5 1035.5 709.008 1035.5 701C1035.5 692.992 1041.99 686.5 1050 686.5C1058.01 686.5 1064.5 692.992 1064.5 701Z"
                fill="white"
                stroke="white"
              />
            </svg>
            <div class="white-line-mobile" v-show="isMobile || isTablet"></div>
          </div>
        </div>
        <div class="white-line" v-show="isDesktop"></div>

        <!-- -------------------------------------------------------------------------- -->
        <!--                               DESCRIPTION SECTION                          -->
        <!-- -------------------------------------------------------------------------- -->

        <section id="lorem-desc">
          <div class="due">
            <h1 class="desc">
              <!-- Creativity an ever-evolving force.<br /> -->
              <strong>Endor</strong> is dedicated to taking
              <br v-if="isDesktop" />
              your vision to the next level by <br v-if="isDesktop" />
              leveraging design and technology.
              <br />
              We bring ideas to life.
            </h1>
          </div>
        </section>

        <!-- -------------------------------------------------------------------------- -->
        <!--                               WEB3 & DESIGN                                -->
        <!-- -------------------------------------------------------------------------- -->

        <section id="services">
          <div class="tre">
            <div class="orbits-container">
              <div
                class="orbits-web"
                id="orbits-web"
                :class="isWebHover ? 'web-hover' : ''"
                @mouseenter="isWebHover = true"
                @mouseleave="isWebHover = false"
                @click="openWebModal()"
              ></div>
              <div
                class="orbits-design"
                id="orbits-des"
                :class="isDesignHover ? 'des-hover' : ''"
                @mouseenter="isDesignHover = true"
                @mouseleave="isDesignHover = false"
                @click="openDesignModal()"
              ></div>
              <div @click="scrollToSection('duna')" class="orbits-duna"></div>
              <svg
                class="orbits"
                width="1341"
                height="149"
                viewBox="0 0 1341 149"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M678.102 47.898C732.274 47.2022 776.142 42.9706 776.084 38.4466C776.026 33.9225 732.065 30.8191 677.893 31.5149C623.721 32.2107 579.853 36.4423 579.911 40.9663C579.968 45.4904 623.93 48.5938 678.102 47.898Z"
                  stroke="white"
                  stroke-width="0.75"
                  stroke-miterlimit="10"
                />

                <path
                  d="M686.829 66.6312C787.798 65.3343 869.542 55.9076 869.41 45.576C869.278 35.2445 787.32 27.9204 686.352 29.2173C585.384 30.5142 503.64 39.9409 503.771 50.2725C503.903 60.604 585.861 67.9281 686.829 66.6312Z"
                  stroke="white"
                  stroke-width="0.75"
                  stroke-miterlimit="10"
                />
                <path
                  d="M673.208 87.0294C836.269 84.9349 968.283 69.7145 968.07 53.0335C967.857 36.3526 835.498 24.5279 672.438 26.6224C509.377 28.7168 377.362 43.9372 377.575 60.6182C377.788 77.2991 510.147 89.1238 673.208 87.0294Z"
                  stroke="white"
                  stroke-width="0.75"
                  stroke-miterlimit="10"
                />
                <path
                  d="M681.122 117.786C942.424 114.43 1153.98 90.0363 1153.63 63.3019C1153.29 36.5675 941.19 17.6158 679.888 20.9721C418.586 24.3284 207.035 48.7217 207.376 75.4561C207.717 102.191 419.82 121.142 681.122 117.786Z"
                  stroke="white"
                  stroke-width="0.75"
                  stroke-miterlimit="10"
                />
                <path
                  d="M670.531 143.095C1040.28 140.279 1339.78 107.105 1339.49 68.998C1339.2 30.8915 1039.22 2.28272 669.481 5.09858C299.737 7.91444 0.23526 41.0886 0.525468 79.1951C0.815677 117.302 300.788 145.91 670.531 143.095Z"
                  stroke="white"
                  stroke-miterlimit="10"
                />
              </svg>
            </div>

            <div class="design col-6">
              <div class="text servizi-fade">
                <p>
                  We are focused to crafting captivating solutions that
                  mesmerize your audience and make a <b>lasting impact.</b>
                  Online presence that elevates your brand to
                  <b>new heights</b>.
                </p>
              </div>

              <div class="fade-tre">
                <h1
                  v-if="isDesktop"
                  class="des-fade text-animation"
                  :class="isDesignHover ? 'des-h1-hover' : ''"
                  @click="openDesignModal()"
                  @mouseenter="isDesignHover = true"
                  @mouseleave="isDesignHover = false"
                >
                  DESIGN
                </h1>
              </div>
            </div>

            <div v-if="isDesktop" class="web col-6">
              <div class="fade-tre">
                <h1
                  class="web-fade text-animation"
                  :class="isWebHover ? 'web-h1-hover' : ''"
                  @click="openWebModal()"
                  @mouseenter="isWebHover = true"
                  @mouseleave="isWebHover = false"
                >
                  CODE
                </h1>
              </div>
            </div>

            <div
              v-if="isMobile || isTablet"
              class="servizi-mobile-btn-container"
            >
              <button class="servizi-mobile-btn">
                <h1
                  class="button-txt text-animation"
                  @click="openDesignModal()"
                >
                  DESIGN
                </h1>
              </button>

              <button class="servizi-mobile-btn">
                <h1 class="button-txt text-animation" @click="openWebModal()">
                  CODE
                </h1>
              </button>
            </div>

            <!-- -------------------------------------------------------------------------- -->
            <!--                               DESIGN MODAL                                -->
            <!-- -------------------------------------------------------------------------- -->

            <div class="branding" v-if="isDesignOpen">
              <div class="servizi-text">
                <div class="back-btn">
                  <button @click="closeModal()">
                    <img
                      src="../assets/img/modal-arrow.svg"
                      alt="go back"
                      draggable="false"
                    />
                  </button>
                </div>
                <div class="servizi-title-cnt">
                  <h1
                    key="modal-title-des-1"
                    class="modal-text"
                    v-if="desPhase == 0"
                  >
                    DESIGN
                  </h1>
                  <h1
                    key="modal-title-des-2"
                    class="modal-text"
                    v-if="desPhase == 1"
                  >
                    BRANDING
                  </h1>
                </div>
                <div class="line-container">
                  <div class="line"></div>
                  <button
                    @click="SwipeDesign()"
                    id="web-swipe"
                    :class="'des-phase des-phase-' + desPhase"
                  >
                    <div class="circle-swipe">
                      <p v-if="isDesktop || isTablet">TAP TO SWIPE</p>
                      <p v-if="isMobile" class="mob-tap">
                        TAP TO<br />
                        SWIPE
                      </p>
                    </div>
                  </button>
                </div>
                <div class="text">
                  <p
                    key="modal-text-des-1"
                    class="modal-text"
                    v-if="desPhase == 0"
                  >
                    Our design service is an imaginative journey that celebrates
                    <b>your brand’s essence</b>. We craft visuals that connect
                    with your audience, creating a sensory experience that
                    captivates and inspires. From concept to execution, we are
                    dedicated to creating designs that are as
                    <b>unique as you are</b>.
                  </p>
                  <p
                    key="modal-text-des-2"
                    class="modal-text"
                    v-if="desPhase == 1"
                  >
                    We're all about discovering the soul of your brand. We work
                    with you to define your brand’s values and vision, and then
                    craft a custom identity that captures its essence. From
                    <b>logo to custom proprietary font</b>, we create a
                    memorable brand that connects with your audience and sets
                    you apart from the competition.
                  </p>
                </div>
                <button v-if="isMobile || isTablet" class="servizi-mobile-btn">
                  <h1 class="button-txt" @click="closeModal()">DESIGN</h1>
                </button>
              </div>
            </div>

            <!-- -------------------------------------------------------------------------- -->
            <!--                                 WEB MODAL                                  -->
            <!-- -------------------------------------------------------------------------- -->

            <div class="consulenza" v-if="isWebOpen">
              <div class="servizi-text">
                <div class="back-btn">
                  <button @click="closeModal()">
                    <img
                      src="../assets/img/modal-arrow.svg"
                      alt="go back"
                      draggable="false"
                    />
                  </button>
                </div>
                <div class="servizi-title-cnt">
                  <h1
                    key="modal-title-web-1"
                    class="modal-text"
                    v-if="webPhase == 0 && !isMobile"
                  >
                    CONSULTING
                  </h1>
                  <h1
                    key="modal-title-web-2"
                    class="modal-text"
                    v-if="webPhase == 0 && isMobile"
                  >
                    CONSULTING
                  </h1>
                  <h1
                    key="modal-title-web-3"
                    class="modal-text"
                    v-if="webPhase == 1"
                  >
                    DEVELOPMENT
                  </h1>
                  <h1
                    key="modal-title-web-4"
                    class="modal-text"
                    v-if="webPhase == 2"
                  >
                    WEB 3.0
                  </h1>
                </div>
                <div class="line-container">
                  <div class="line"></div>
                  <button
                    @click="SwipeWeb()"
                    id="web-swipe"
                    :class="'web-phase web-phase-' + webPhase"
                  >
                    <div class="circle-swipe">
                      <p v-if="isDesktop || isTablet">TAP TO SWIPE</p>
                      <p v-if="isMobile" class="mob-tap">
                        TAP TO<br />
                        SWIPE
                      </p>
                    </div>
                  </button>
                </div>
                <div class="text">
                  <p
                    key="modal-text-web-1"
                    class="modal-text"
                    v-if="webPhase == 0"
                  >
                    Let us be your guide in discovering the
                    <b>best solution</b> for your needs. We will help you
                    navigate the complexities of the market, identify your
                    unique strengths, and craft a solution that aligns with
                    <b>your goals</b>.
                  </p>
                  <p
                    key="modal-text-web-2"
                    class="modal-text"
                    v-if="webPhase == 1"
                  >
                    We build immersive experiences that engage and inspire.
                    Combining cutting-edge technology with artistic vision to
                    create a world that is as exciting as it is
                    <b>beautiful</b>. Whether you’re looking to create an
                    amazing website, an interactive art installation, or
                    anything in between, we have the skills and expertise to
                    <b>bring your vision to life</b>.
                  </p>
                  <p
                    key="modal-text-web-3"
                    class="modal-text"
                    v-if="webPhase == 2"
                  >
                    We specialize in creating <b>smart contracts</b>,
                    decentralized apps and building <b>metaverse</b> experiences
                    that are user-centric. With our innovative approach and
                    expert guidance, we help you navigate the world of Web3 and
                    build a future-proof solution that meets your needs and
                    exceeds your expectations.
                  </p>
                  <!-- <p
                    key="modal-text-web-4"
                    class="modal-text"
                    v-if="webPhase == 3"
                  >
                    Sviluppiamo smart contract custom che danno la possibilità
                    di interagire direttamente con qualunque Blockchain EVM
                    compatible, il segreto per poter generare il massimo valore
                    in ogni situazione. Questa skill ci permette di integrarci o
                    creare infrastrutture digitali complesse altrimenti
                    irrealizzabili.
                  </p> -->
                </div>
                <button
                  v-show="isMobile || isTablet"
                  class="servizi-mobile-btn"
                >
                  <h1 class="button-txt" @click="closeModal()">CODE</h1>
                </button>
              </div>
            </div>
          </div>
        </section>

        <!-- -------------------------------------------------------------------------- -->
        <!--                                DUNA SECTION                                -->
        <!-- -------------------------------------------------------------------------- -->

        <section class="long" id="duna">
          <div class="wrapper">
            <div class="duna">
              <div
                :style="{
                  opacity:
                    dunaShadowRunning ||
                    (transitionRunning && newSectionTransition === 'duna')
                      ? 0
                      : 1,
                }"
                class="duna-svg-ctn"
              >
                <svg
                  class="duna-svg"
                  width="2723"
                  height="244"
                  viewBox="0 0 2723 244"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 0V24.9745H546.825C600.118 24.9745 643.275 68.1311 643.275 121.424C643.275 174.717 600.118 217.873 546.825 217.873H537.107L365.839 164.058C313.591 147.652 256.641 161.655 217.873 200.318C206.588 211.603 191.122 218.709 175.135 218.709H0.104502V243.788H636.273L678.072 201.99V45.142L628.645 0H0Z"
                    fill="#ffa200"
                  />
                  <path
                    d="M1317.69 0C1317.69 120.274 1220.19 217.873 1099.81 217.873H1059.79H989.049H949.028C828.753 217.873 731.154 120.379 731.154 0H696.984V201.99L737.633 243.788H989.049H1059.79H1311.21L1351.86 201.99V0H1317.69Z"
                    fill="#ffa200"
                  />
                  <path
                    d="M1733.58 0H1662.84H1411.42L1370.77 41.7982V243.788H1404.94C1404.94 123.514 1502.44 25.9148 1622.82 25.9148H1662.84H1733.58H1773.6C1893.88 25.9148 1991.48 123.409 1991.48 243.788H2025.65V41.7982L1985 0H1733.58Z"
                    fill="#ffa200"
                  />
                  <path
                    d="M2673.54 0H2045V24.9745H2591.72C2645.01 24.9745 2688.17 68.131 2688.17 121.424C2688.17 174.717 2644.8 218.709 2591.51 218.709H2581.79L2410.73 164.058C2358.49 147.652 2301.54 161.655 2262.77 200.318C2251.48 211.603 2236.54 218.709 2220.66 218.709H2118.67C2107.38 218.709 2102.68 203.244 2112.09 196.974C2154.51 168.76 2240.51 121.842 2344.07 121.842C2492.14 121.842 2584.93 186.42 2584.93 186.42H2602.38C2625.05 186.42 2643.45 168.029 2643.45 145.353C2643.45 122.678 2625.05 104.286 2602.38 104.286H2584.93H2124.1C2080.42 104.286 2045 139.711 2045 183.39V243.684H2083.98H2681.06L2722.86 201.885V45.0376L2673.54 0Z"
                    fill="#ffa200"
                  />
                </svg>
              </div>

              <div class="duna-text">
                <p>
                  <span class="duna-body">
                    Endor’s first platform, <b>DUNA</b> is a cutting-edge
                    solution that provides businesses with a versatile digital
                    space for organizing events and meetings. With seamless
                    accessibility across
                    <b>desktop, smartphone, and VR devices</b>, we ensure that
                    attendees can connect from anywhere in the world. Whether
                    you’re hosting a
                    <b>business meeting or a large-scale event</b>, DUNA is the
                    ultimate virtual solution.
                    <span
                      :class="!isMobile && !isTablet ? 'd-none' : ''"
                      class="duna-circle-mobile"
                    ></span>
                  </span>
                </p>
              </div>
              <span
                :class="isMobile || isTablet ? 'd-none' : ''"
                class="duna-circle"
              ></span>
            </div>
          </div>
        </section>

        <section class="duna-prev-section">
          <div class="duna-prev">
            <div class="black-gradient"></div>

            <div class="img-container">
              <div class="duna-img-mobile" v-show="isMobile"></div>
              <div class="duna-img" v-show="!isMobile"></div>

              <button @click="openDunaLanding()" class="de-button">
                TRY THE DIGITAL EXPERIENCE
              </button>
            </div>

            <div class="white-gradient"></div>
          </div>
        </section>

        <!-- -------------------------------------------------------------------------- -->
        <!--                             CONTATTI SECTION                               -->
        <!-- -------------------------------------------------------------------------- -->

        <section id="contact">
          <!-- <section id="contact"> -->
          <div class="contatti">
            <div class="links">
              <h1>
                Are you ready<br v-if="isDesktop"/>
                to enter our world?
              </h1>
              <div class="bottoni">
                <button @click="openForm()">contact us</button>
                <div class="social">
                  <a
                    href="https://www.instagram.com/endor.studio/"
                    target="_blank"
                  >
                    <svg
                      width="31"
                      height="31"
                      viewBox="0 0 31 31"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M15.5 0.875C11.5279 0.875 11.0306 0.891575 9.4706 0.96275C7.91353 1.03393 6.8498 1.28158 5.91965 1.6433C4.94465 2.0099 4.06033 2.58515 3.32908 3.33005C2.58537 4.06046 2.00976 4.94416 1.64233 5.91965C1.28255 6.8498 1.03393 7.9145 0.96275 9.47158C0.89255 11.0306 0.875 11.5269 0.875 15.5C0.875 19.4731 0.891575 19.9694 0.96275 21.5294C1.03393 23.0865 1.28158 24.1502 1.6433 25.0804C2.0099 26.0554 2.58515 26.9397 3.33005 27.6709C4.06048 28.4146 4.94417 28.9902 5.91965 29.3577C6.8498 29.7184 7.91353 29.9661 9.4706 30.0373C11.0306 30.1084 11.5279 30.125 15.5 30.125C19.4722 30.125 19.9694 30.1084 21.5294 30.0373C23.0865 29.9661 24.1502 29.7184 25.0804 29.3567C26.0554 28.9901 26.9397 28.4149 27.6709 27.67C28.4146 26.9395 28.9902 26.0558 29.3577 25.0804C29.7184 24.1502 29.9661 23.0865 30.0373 21.5294C30.1084 19.9694 30.125 19.4722 30.125 15.5C30.125 11.5279 30.1084 11.0306 30.0373 9.4706C29.9661 7.91353 29.7184 6.8498 29.3567 5.91965C28.9895 4.94374 28.4139 4.05966 27.67 3.32908C26.9395 2.58537 26.0558 2.00976 25.0804 1.64233C24.1502 1.28255 23.0855 1.03393 21.5284 0.96275C19.9694 0.89255 19.4731 0.875 15.5 0.875ZM15.5 3.51043C19.4049 3.51043 19.868 3.52505 21.4105 3.59525C22.8359 3.66058 23.6101 3.8975 24.1258 4.09933C24.8083 4.36355 25.2958 4.6814 25.8077 5.1923C26.3196 5.70418 26.6365 6.19168 26.9007 6.87418C27.1015 7.38995 27.3394 8.1641 27.4047 9.58955C27.4749 11.132 27.4896 11.5951 27.4896 15.5C27.4896 19.4049 27.4749 19.868 27.4047 21.4105C27.3394 22.8359 27.1025 23.6101 26.9007 24.1258C26.6666 24.7611 26.2931 25.3358 25.8077 25.8077C25.3359 26.2932 24.7611 26.6667 24.1258 26.9007C23.6101 27.1015 22.8359 27.3394 21.4105 27.4047C19.868 27.4749 19.4059 27.4896 15.5 27.4896C11.5942 27.4896 11.132 27.4749 9.58955 27.4047C8.1641 27.3394 7.38995 27.1025 6.87418 26.9007C6.23892 26.6666 5.66421 26.2931 5.1923 25.8077C4.70692 25.3358 4.33345 24.7611 4.09933 24.1258C3.89847 23.6101 3.66058 22.8359 3.59525 21.4105C3.52505 19.868 3.51043 19.4049 3.51043 15.5C3.51043 11.5951 3.52505 11.132 3.59525 9.58955C3.66058 8.1641 3.8975 7.38995 4.09933 6.87418C4.36355 6.19168 4.6814 5.70418 5.1923 5.1923C5.66414 4.70679 6.23887 4.3333 6.87418 4.09933C7.38995 3.89847 8.1641 3.66058 9.58955 3.59525C11.132 3.52505 11.5951 3.51043 15.5 3.51043V3.51043Z"
                        fill="black"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M15.5 20.3799C14.8591 20.3799 14.2246 20.2537 13.6325 20.0084C13.0405 19.7632 12.5025 19.4038 12.0494 18.9506C11.5962 18.4975 11.2368 17.9595 10.9916 17.3675C10.7463 16.7754 10.6201 16.1409 10.6201 15.5C10.6201 14.8592 10.7463 14.2246 10.9916 13.6326C11.2368 13.0405 11.5962 12.5026 12.0494 12.0494C12.5025 11.5963 13.0405 11.2368 13.6325 10.9916C14.2246 10.7464 14.8591 10.6201 15.5 10.6201C16.7942 10.6201 18.0354 11.1343 18.9506 12.0494C19.8657 12.9646 20.3798 14.2058 20.3798 15.5C20.3798 16.7942 19.8657 18.0355 18.9506 18.9506C18.0354 19.8658 16.7942 20.3799 15.5 20.3799V20.3799ZM15.5 7.98277C13.5063 7.98277 11.5942 8.77477 10.1845 10.1845C8.77472 11.5943 7.98273 13.5063 7.98273 15.5C7.98273 17.4937 8.77472 19.4058 10.1845 20.8155C11.5942 22.2253 13.5063 23.0173 15.5 23.0173C17.4937 23.0173 19.4057 22.2253 20.8155 20.8155C22.2252 19.4058 23.0172 17.4937 23.0172 15.5C23.0172 13.5063 22.2252 11.5943 20.8155 10.1845C19.4057 8.77477 17.4937 7.98277 15.5 7.98277V7.98277ZM25.2041 7.84627C25.2041 8.31755 25.0169 8.76952 24.6837 9.10276C24.3505 9.436 23.8985 9.62321 23.4272 9.62321C22.9559 9.62321 22.504 9.436 22.1707 9.10276C21.8375 8.76952 21.6503 8.31755 21.6503 7.84627C21.6503 7.375 21.8375 6.92303 22.1707 6.58979C22.504 6.25655 22.9559 6.06934 23.4272 6.06934C23.8985 6.06934 24.3505 6.25655 24.6837 6.58979C25.0169 6.92303 25.2041 7.375 25.2041 7.84627"
                        fill="black"
                      />
                    </svg>
                  </a>
                  <a href="https://twitter.com/Endor_studio" target="_blank">
                    <svg
                      width="34"
                      height="27"
                      viewBox="0 0 34 27"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M30.2548 6.87006C30.2751 7.15657 30.2751 7.44308 30.2751 7.73224C30.2751 16.5428 23.3958 26.7041 10.8168 26.7041V26.6988C7.10086 26.7041 3.46216 25.6663 0.333984 23.7096C0.874305 23.773 1.41733 23.8046 1.96172 23.806C5.04114 23.8086 8.03254 22.8012 10.4552 20.9461C7.52878 20.892 4.9626 19.0316 4.06613 16.3157C5.09125 16.5085 6.14751 16.4689 7.15368 16.2009C3.96321 15.5724 1.66786 12.8393 1.66786 9.6652C1.66786 9.63616 1.66786 9.60843 1.66786 9.5807C2.6185 10.097 3.68289 10.3835 4.77166 10.4152C1.76672 8.4571 0.840451 4.55948 2.65506 1.51215C6.1272 5.6778 11.2501 8.2102 16.7495 8.47823C16.1983 6.16236 16.9512 3.73559 18.7279 2.10762C21.4823 -0.416857 25.8144 -0.287464 28.4036 2.39677C29.9352 2.10234 31.4031 1.5544 32.7465 0.778044C32.2359 2.32151 31.1675 3.6326 29.7402 4.46573C31.0957 4.30994 32.4201 3.95609 33.6673 3.41607C32.7492 4.75753 31.5927 5.92602 30.2548 6.87006Z"
                        fill="black"
                      />
                    </svg>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/85668038/"
                    target="_blank"
                  >
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M29.25 2.15074V27.0993C29.25 27.6697 29.0234 28.2167 28.6201 28.6201C28.2167 29.0234 27.6697 29.25 27.0993 29.25H2.15074C1.58032 29.25 1.03328 29.0234 0.629936 28.6201C0.226595 28.2167 0 27.6697 0 27.0993L0 2.15074C0 1.58032 0.226595 1.03328 0.629936 0.629936C1.03328 0.226595 1.58032 0 2.15074 0L27.0993 0C27.6697 0 28.2167 0.226595 28.6201 0.629936C29.0234 1.03328 29.25 1.58032 29.25 2.15074V2.15074ZM8.60294 11.1838H4.30147V24.9485H8.60294V11.1838ZM8.99007 6.45221C8.99234 6.12683 8.9305 5.8042 8.80807 5.50273C8.68565 5.20126 8.50505 4.92686 8.27657 4.69519C8.0481 4.46352 7.77623 4.27912 7.47649 4.15252C7.17675 4.02592 6.855 3.9596 6.52963 3.95735H6.45221C5.79053 3.95735 5.15595 4.2202 4.68808 4.68808C4.2202 5.15595 3.95735 5.79053 3.95735 6.45221C3.95735 7.11388 4.2202 7.74846 4.68808 8.21633C5.15595 8.68421 5.79053 8.94706 6.45221 8.94706V8.94706C6.7776 8.95506 7.10138 8.89887 7.40505 8.7817C7.70872 8.66453 7.98633 8.48867 8.22201 8.26417C8.4577 8.03968 8.64683 7.77094 8.77862 7.47332C8.91041 7.1757 8.98226 6.85503 8.99007 6.52963V6.45221ZM24.9485 16.5865C24.9485 12.4485 22.316 10.8397 19.7007 10.8397C18.8444 10.7968 17.9919 10.9792 17.228 11.3687C16.4642 11.7581 15.8159 12.341 15.3476 13.0593H15.2272V11.1838H11.1838V24.9485H15.4853V17.6274C15.4231 16.8776 15.6593 16.1336 16.1425 15.5569C16.6258 14.9802 17.3171 14.6175 18.0662 14.5476H18.2296C19.5975 14.5476 20.6126 15.4079 20.6126 17.5758V24.9485H24.9141L24.9485 16.5865Z"
                        fill="black"
                      />
                    </svg>
                  </a>
                  <a href="https://www.behance.net/endorstudio" target="_blank">
                    <svg
                      width="40"
                      height="40"
                      viewBox="2 0 20 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22 7h-7v-2h7v2zm1.726 10c-.442 1.297-2.029 3-5.101 3-3.074 0-5.564-1.729-5.564-5.675 0-3.91 2.325-5.92 5.466-5.92 3.082 0 4.964 1.782 5.375 4.426.078.506.109 1.188.095 2.14h-8.027c.13 3.211 3.483 3.312 4.588 2.029h3.168zm-7.686-4h4.965c-.105-1.547-1.136-2.219-2.477-2.219-1.466 0-2.277.768-2.488 2.219zm-9.574 6.988h-6.466v-14.967h6.953c5.476.081 5.58 5.444 2.72 6.906 3.461 1.26 3.577 8.061-3.207 8.061zm-3.466-8.988h3.584c2.508 0 2.906-3-.312-3h-3.272v3zm3.391 3h-3.391v3.016h3.341c3.055 0 2.868-3.016.05-3.016z"
                        fill="black"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <footer>
              <p>2023 @ENDOR srl. All Rights Reserved | VAT: IT04047360369</p>
              <p>
                <a
                  href="https://www.iubenda.com/privacy-policy/29646057"
                  class="iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe"
                  title="Privacy Policy "
                  target="_blank"
                  >Privacy Policy</a
                >
                <span> - </span>
                <a
                  href="https://www.iubenda.com/privacy-policy/29646057/cookie-policy"
                  class="iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe"
                  title="Cookie Policy "
                  target="_blank"
                  >Cookie Policy</a
                >
              </p>
            </footer>
          </div>
        </section>

        <!-- -------------------------------------------------------------------------- -->
        <!--                                 FORM SECTION                               -->
        <!-- -------------------------------------------------------------------------- -->
      </div>
      <div v-show="dunaShadowRunning" class="duna-anim-ctn">
        <div
          class="duna-anim-svg-box"
          :style="{
            width: dunaShadowSize.width + 'px',
          }"
        >
          <svg
            class="duna-anim-svg"
            width="2723"
            height="244"
            viewBox="0 0 2723 244"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 0V24.9745H546.825C600.118 24.9745 643.275 68.1311 643.275 121.424C643.275 174.717 600.118 217.873 546.825 217.873H537.107L365.839 164.058C313.591 147.652 256.641 161.655 217.873 200.318C206.588 211.603 191.122 218.709 175.135 218.709H0.104502V243.788H636.273L678.072 201.99V45.142L628.645 0H0Z"
              fill="#ffa200"
            />
            <path
              d="M1317.69 0C1317.69 120.274 1220.19 217.873 1099.81 217.873H1059.79H989.049H949.028C828.753 217.873 731.154 120.379 731.154 0H696.984V201.99L737.633 243.788H989.049H1059.79H1311.21L1351.86 201.99V0H1317.69Z"
              fill="#ffa200"
            />
            <path
              d="M1733.58 0H1662.84H1411.42L1370.77 41.7982V243.788H1404.94C1404.94 123.514 1502.44 25.9148 1622.82 25.9148H1662.84H1733.58H1773.6C1893.88 25.9148 1991.48 123.409 1991.48 243.788H2025.65V41.7982L1985 0H1733.58Z"
              fill="#ffa200"
            />
            <path
              d="M2673.54 0H2045V24.9745H2591.72C2645.01 24.9745 2688.17 68.131 2688.17 121.424C2688.17 174.717 2644.8 218.709 2591.51 218.709H2581.79L2410.73 164.058C2358.49 147.652 2301.54 161.655 2262.77 200.318C2251.48 211.603 2236.54 218.709 2220.66 218.709H2118.67C2107.38 218.709 2102.68 203.244 2112.09 196.974C2154.51 168.76 2240.51 121.842 2344.07 121.842C2492.14 121.842 2584.93 186.42 2584.93 186.42H2602.38C2625.05 186.42 2643.45 168.029 2643.45 145.353C2643.45 122.678 2625.05 104.286 2602.38 104.286H2584.93H2124.1C2080.42 104.286 2045 139.711 2045 183.39V243.684H2083.98H2681.06L2722.86 201.885V45.0376L2673.54 0Z"
              fill="#ffa200"
            />
          </svg>
        </div>
      </div>
    </div>
    <Loader
      v-if="splashOpen"
      :loading="pageLoading"
      :exitAnimationRunning="splashExitRunning"
      id="loader"
      @onCloseClick="OnSplashClose"
      @onVideoEnd="
        () => {
          pageLoading = false;
          // initGsapLoaderAnimation();
        }
      "
    />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Loader from "@/components/Loader.vue";
import checkViewport from "@/mixins/checkViewport";
import { gsap } from "gsap";

export default {
  name: "Home",
  mixins: [checkViewport],
  components: {
    Header,
    Loader,
  },

  data() {
    return {
      scrollController: null,
      pageLoading: true,
      webPhase: 0,
      desPhase: 0,
      isDesignClicked: false,
      isDesignHover: false,
      isDesignOpen: false,
      isWebOpen: false,
      isWebClicked: false,
      isWebHover: false,
      isClosingModalAnim: false,
      modalCircleCoordinates: {
        bottom: 0,
        left: 0,
      },
      isFormOpen: false,
      formName: "",
      formEmail: "",
      formPhone: "",
      formMessage: "",
      formCommunication: "",
      darkHeader: false,
      splashOpen: true,
      splashExitRunning: false,
      blackLoaderCtn: null,
      previousTouch: null,
      previousTouchDuna: null,
      transitionRunning: false,
      fadeAnimation: null,
      splashAnimation: null,
      dunaShadowRunning: false,
      currentSection: 0, // home-services-duna-contact
      sectionsSteps: [
        {
          key: "home",
          value: 0,
          pointer: "#home",
        },
        {
          key: "home-2",
          value: innerHeight,
          forcePixelScroll: true,
          subSection: true,
          pointer: "#lorem-desc",
        },
        {
          key: "services",
          value: innerHeight * 2,
          pointer: "#services",
        },
        {
          key: "duna",
          value: innerHeight * 3,
          pointer: "#duna",
        },
        {
          key: "contact",
          value: innerHeight * 4,
          pointer: "#contact",
        },
      ],
      touchTransitioned: false,
      dunaContainer: null,
      dunaNormalizedScroll: 0,
      dunaShadowSize: {
        width: 0,
        height: 0,
      },
      dunaText: null,
      dunaSkipped: false,
      normalizedScroll: 0,
      fadeColor: "#ff0000",
      newSectionTransition: "",
      oldSection: 0,
      isMenuOpen: false,
      skipIntro: false,
      preventSectionDetection: false,
    };
  },

  created() {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    this.skipIntro = this.$route.query.s;
  },
  mounted() {
    this.dunaContainer = document.querySelector(".long");

    this.initScrollDetection();

    const dunaSvg = document.querySelector(".duna-svg-ctn");
    // console.log("dundun", dunaSvg.offsetWidth);
    // console.log("dundun", dunaSvg.offsetHeight);
    this.dunaShadowSize = {
      width: dunaSvg.offsetWidth,
      height: dunaSvg.offsetHeight,
    };
    this.dunaText = document.querySelector(".duna-text");

    this.fadeAnimation = gsap
      .to("#fade-screen", {
        duration: 1,
        keyframes: {
          "20%": {
            opacity: 1,
            onComplete: async () => {
              if (this.isDesignOpen || this.isWebOpen) {
                await this.closeModal();
              }
              await this.scrollToSection(this.newSectionTransition);
            },
          },
          "85%": {
            opacity: 1,
          },
          "100%": {
            opacity: 0,
            onComplete: async () => {
              if (this.newSectionTransition == "duna" && this.oldSection < 2) {
                // console.log("cur", this.currentSection);
                // console.log("oldSection", this.oldSection);
                this.animateDunaShadow();
              }
            },
          },
        },
        onStart: () => {
          // console.log("start");
        },
        onComplete: () => {
          // console.log("transition ende");
          this.transitionRunning = false;
        },
      })
      .pause();
    if (!this.skipIntro) {
      this.splashAnimation = gsap
        .timeline({
          onComplete: () => {
            this.splashExitRunning = false;
            this.splashOpen = false;
          },
        })
        .from(
          ".big-title",
          {
            scale: 0,
            duration: 0.4,
          },
          0
        )
        .to(
          ".logo-loader",
          {
            top: 0,
            left: 0,
            opacity: 0,
            duration: 0.4,
          },
          0
        )
        .pause();
    } else {
      this.pageLoading = false;
      this.splashOpen = false;
    }

    // gsap.timeline({
    //   scrollTrigger: {
    //     trigger: ".black-loader",
    //     start: "bottom bottom",
    //     end: "+=" + innerHeight,
    //     scrub: 0,
    //     // snap: 1,
    //     // pin: 0,
    //     markers: true,
    //   },
    //   onComplete: () => {
    //     console.log("ciao ciao");
    //     document.body._scrollTop = 0;
    //   },
    // });
    // this.animateDunaShadow();
    this.initGsapAnimations();

    // this.initGsapAnimations();
    /* console.log(
      "sdocument.documentElement.clientWidth",
      document.documentElement.clientWidth
    ); */
    /* console.log("scrolll width", this.dunaContainer.scrollWidth); */

    window.scrollTo(0, 0);
    document.body.scrollTop = document.documentElement.scrollTop = 0;

    // setTimeout(() => {
    //   document.getElementsByTagName("html")[0].scrollTo({ top: 6000 });
    // }, 200);
  },
  methods: {
    initGsapAnimations() {
      /* -------------------------------------------------------------------------- */
      /*                         Animazioni prima schermata                         */
      /* -------------------------------------------------------------------------- */
      gsap
        .timeline({
          scrollTrigger: {
            trigger: ".uno",
            start: "0",
            end: "+=" + innerHeight,
            scrub: 0.1,
            duration: 1,
          },
        })
        .to(".big-title", {
          opacity: 0,
        });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: ".due",
            start: "top top",
            end: "+= 20",
            scrub: 0.1,
            duration: 1,
            pin: true,
            autoRemoveChildren: true,
          },
        })
        .to(".desc", {
          opacity: 0,
        });
      gsap
        .timeline({
          scrollTrigger: {
            trigger: ".uno",
            start: "top top",
            end: "+=150",
            scrub: 0.1,
            duration: 5,
          },
        })
        .to(".rotating", {
          rotation: 105,
        });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: ".uno",
            start: "top top",
            end: "+=150",
            scrub: 0.1,
            duration: 5,
          },
        })
        .to(".rotating-mobile", {
          rotation: 219,
        });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: ".uno",
            start: "0",
            end: "+=50",
            scrub: 0.1,
          },
        })
        .to(".scritta", {
          opacity: 0,
        });

      /* -------------------------------------------------------------------------- */
      /*                      Animazioni schermata descrizione                      */
      /* -------------------------------------------------------------------------- */

      gsap
        .timeline({
          scrollTrigger: {
            trigger: ".due",
            start: "bottom bottom",
            end: "+55%",
            scrub: 0.5,
            duration: 0.5,
            autoRemoveChildren: true,
          },
        })
        .to(".circle-container", {
          keyframes: [
            {
              opacity: "0.5",
            },
            {
              opacity: "0",
            },
            {
              display: "none",
            },
          ],
        });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: ".due",
            start: "0",
            end: "+=" + innerHeight,
            scrub: 0.1,
            duration: 1,
          },
        })
        .to(".desc", {
          opacity: 0,
        });

      /* -------------------------------------------------------------------------- */
      /*                     Animazioni schermata web3 & design                     */
      /* -------------------------------------------------------------------------- */

      gsap
        .timeline({
          scrollTrigger: {
            trigger: ".tre",
            start: "0",
            end: "+=" + innerHeight / 2,
            scrub: 0.1,
            duration: 1,
          },
        })
        .to(".servizi-fade", {
          opacity: 0,
        });

      if (this.isDesktop) {
        setTimeout(() => {
          gsap
            .timeline({
              scrollTrigger: {
                trigger: ".tre",
                start: "70%",
                end: "90%",
                scrub: 0.1,
                duration: 1,
              },
            })
            .to(".fade-tre", {
              opacity: 0,
            });
        }, 10);
      }

      gsap
        .timeline({
          scrollTrigger: {
            trigger: ".due",
            start: "150vh",
            end: "+=30",
            scrub: 0.1,
            duration: 0.1,
            autoRemoveChildren: true,
          },
        })
        .to(".white-line", {
          keyframes: [
            {
              rotate: 90,
            },
          ],
        });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: ".due",
            start: "bottom bottom",
            end: "+=30",
            scrub: 0.3,
            duration: 0.1,
            autoRemoveChildren: true,
          },
        })
        .to(".white-line-mobile", {
          keyframes: [
            {
              opacity: "0.5",
            },
            {
              opacity: "0",
            },
            {
              display: "none",
            },
          ],
        });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: ".tre",
            start: "bottom bottom",
            end: "+=55%",
            scrub: 0.3,
            duration: 1,
            autoRemoveChildren: true,
          },
        })
        .to(".white-line", {
          keyframes: [
            {
              opacity: "0.5",
            },
            {
              opacity: "0",
            },
            {
              display: "none",
            },
          ],
        });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: ".tre",
            start: "-10%",
            end: "+=0",
            scrub: 0.5,
            duration: 0.5,
          },
        })
        .to(".orbits-container", {
          keyframes: [
            {
              opacity: 1,
            },
          ],
        });

      /* -------------------------------------------------------------------------- */
      /*                     Animazioni schermata duna                              */
      /* -------------------------------------------------------------------------- */

      /*     console.log("offsetWidth", this.dunaContainer.offsetWidth); */
      gsap
        .timeline({
          scrollTrigger: {
            trigger: "#duna",
            pin: true,
            toggleActions: "resume none reverse none",
            scrub: 0,
            end: () => "+=" + this.dunaContainer.offsetWidth * 1.5,
          },
        })
        .to("#duna", {
          x: () =>
            this.isMobile
              ? "-400vw"
              : -(
                  this.dunaContainer.scrollWidth -
                  document.documentElement.clientWidth +
                  100
                ) + "px",
        })
        .from(
          ".duna-body",
          {
            y: "500px",
          },
          0
        );
    },
    animateDunaShadow() {
      this.dunaShadowRunning = true;
      gsap
        .timeline({
          onComplete: () => {
            this.dunaShadowRunning = false;
          },
        })
        .from(
          ".duna-anim-svg",
          {
            width: "0",
            duration: 0.5,
          },
          0
        )
        .to(
          ".duna-anim-svg-box",
          {
            keyframes: {
              "0%": {
                marginTop: 0,
                y: 0,
              },
              "99%": {
                marginTop: -this.dunaShadowSize.height / 2 + "px",
                y: "50vh",
              },
            },

            duration: 0.5,
          },
          0
        );
      // .to(
      //   ".duna-anim-svg-box",
      //   {
      //     opacity: 0,
      //     duration: 0.8,
      //   },
      //   0
      // );
    },
    splashTimeout() {
      this.pageLoading = false;
    },

    initScrollDetection() {
      // evita di poter scrollare la pagina quando sei dentro una modale o nella schermata di caricamento
      const homeContainer = window;
      homeContainer.addEventListener("scroll", () => {
        // if (this.isWebOpen || this.isDesignOpen) {
        //   console.log("ciao ciao");
        //   e.preventDefault();
        //   e.stopPropagation();
        //   return;
        // }

        this.normalizedScroll =
          window.scrollY / (document.body.scrollHeight - window.innerHeight);
        if (!this.transitionRunning) {
          // console.log(this.normalizedScroll);

          if (this.normalizedScroll < 0.25) {
            if (this.currentSection != 0) this.currentSection = 0;
          } else if (this.normalizedScroll < 0.4) {
            if (this.currentSection != 1) this.currentSection = 1;
          } else if (this.normalizedScroll < 0.9) {
            if (this.currentSection != 2) this.currentSection = 2;
          } else {
            if (this.currentSection != 3) this.currentSection = 3;
          }
        }

        if (this.normalizedScroll > 0.99) {
          if (!this.darkHeader) this.darkHeader = true;
        } else if (this.darkHeader) this.darkHeader = false;
      });

      const onePageContainer = document.getElementById("one-page-content");
      onePageContainer.addEventListener("scroll", (e) => {
        // console.log("scroll onePageContainer");
        if (
          this.isWebOpen ||
          this.isDesignOpen ||
          this.isFormOpen ||
          this.isMenuOpen ||
          this.transitionRunning
        ) {
          // console.log("stopping event");
          e.preventDefault();
          e.stopPropagation();
        }
      });
      // onePageContainer.addEventListener("wheel", (e) => {
      //   // console.log("scroll onePageContainer");
      //   if (
      //     this.isWebOpen ||
      //     this.isDesignOpen ||
      //     this.isFormOpen ||
      //     this.isMenuOpen ||
      //     this.transitionRunning
      //   ) {
      //     // console.log("stopping event");
      //     e.preventDefault();
      //     e.stopPropagation();
      //   }
      // });
      onePageContainer.addEventListener("touchmove", (e) => {
        // console.log("touchmove onePageContainer");
        if (
          this.isWebOpen ||
          this.isDesignOpen ||
          this.isFormOpen ||
          this.isMenuOpen ||
          this.transitionRunning
        ) {
          // console.log("stopping event");
          e.preventDefault();
          e.stopPropagation();
        }
      });
      this.blackLoaderCtn = document.querySelector(".black-loader-ctn");
      if (this.blackLoaderCtn) {
        this.blackLoaderCtn.addEventListener("scroll", this.listenLoaderScroll);
        this.blackLoaderCtn.addEventListener(
          "touchmove",
          this.listenLoaderScroll
        );
      }
      // const formModalContainer = document.getElementById(
      //   "form-modal-container"
      // );
      // formModalContainer.addEventListener("scroll", (e) => {
      //   console.log("scroll formModalContainer");
      //   if (this.isWebOpen || this.isDesignOpen || this.isFormOpen) {
      //     console.log("stopping event");
      //     e.preventDefault();
      //     e.stopPropagation();
      //   }
      // });
      // formModalContainer.addEventListener("touchmove", (e) => {
      //   console.log("touchmove formModalContainer");
      //   if (this.isWebOpen || this.isDesignOpen || this.isFormOpen) {
      //     console.log("stopping event");
      //     e.preventDefault();
      //     e.stopPropagation();
      //   }
      // });
      // setTimeout(() => {
      //   const iFrameContainer =
      //     document.getElementById("hs-form-iframe-0").contentWindow.document;
      //   iFrameContainer.addEventListener("scroll", (e) => {
      //     console.log("scroll iFrameContainer");
      //     console.log("stopping event");
      //     e.preventDefault();
      //     e.stopPropagation();
      //   });
      //   iFrameContainer.addEventListener("touchmove", (e) => {
      //     console.log("touchmove iFrameContainer");
      //     console.log("stopping event");
      //     e.preventDefault();
      //     e.stopPropagation();
      //   });
      // }, 2000);
      // const formContainer = document.getElementById("form-container");
      // formContainer.addEventListener("scroll", (e) => {
      //   console.log("scroll formContainer");
      //   if (this.isWebOpen || this.isDesignOpen || this.isFormOpen) {
      //     console.log("stopping event");
      //     e.preventDefault();
      //     e.stopPropagation();
      //   }
      // });
      // formContainer.addEventListener("touchmove", (e) => {
      //   console.log("touchmove formContainer");
      //   if (this.isWebOpen || this.isDesignOpen || this.isFormOpen) {
      //     console.log("stopping event");
      //     e.preventDefault();
      //     e.stopPropagation();
      //   }
      // });
      // const contactsContainer = document.getElementById("contact");
      // contactsContainer.addEventListener("scroll", (e) => {
      //   console.log("scroll contactsContainer");
      //   if (this.isWebOpen || this.isDesignOpen || this.isFormOpen) {
      //     console.log("stopping event");
      //     e.preventDefault();
      //     e.stopPropagation();
      //   }
      // });
      // contactsContainer.addEventListener("touchmove", (e) => {
      //   console.log("touchmove contactsContainer");
      //   if (this.isWebOpen || this.isDesignOpen || this.isFormOpen) {
      //     console.log("stopping event");
      //     e.preventDefault();
      //     e.stopPropagation();
      //   }
      // });
      // const home2Container = document.getElementById("home");
      // home2Container.addEventListener("scroll", (e) => {
      //   console.log("scroll home2Container");
      //   if (this.isWebOpen || this.isDesignOpen || this.isFormOpen) {
      //     console.log("stopping event");
      //     e.preventDefault();
      //     e.stopPropagation();
      //   }
      // });
      // home2Container.addEventListener("touchmove", (e) => {
      //   console.log("touchmove home2Container");
      //   if (this.isWebOpen || this.isDesignOpen || this.isFormOpen) {
      //     console.log("stopping event");
      //     e.preventDefault();
      //     e.stopPropagation();
      //   }
      // });
    },
    listenLoaderScroll() {
      // console.log("listenLoaderScroll");
      this.OnSplashClose();
    },
    onWhoWeAreClick() {
      this.scrollToSection("home-2");
    },
    async onHeaderSectionClick(section) {
      const sectionId = this.sectionsSteps
        .filter(
          (el) =>
            el.subSection == null ||
            el.subSection == undefined ||
            !el.subSection
        )
        .findIndex((el) => el.key == section);
      if (this.currentSection !== sectionId) {
        if (this.isWebOpen) {
          this.fadeColor = "#0400bb";
        } else if (this.isDesignOpen) {
          this.fadeColor = "#ae261e";
        } else {
          this.fadeColor = "#000000";
        }
        this.oldSection = this.currentSection;
        this.transitionRunning = true;
        this.newSectionTransition = section;
        this.currentSection = sectionId;

        this.fadeAnimation.play(0);
      }
    },
    async scrollToSection(section) {
      const sectionId = this.sectionsSteps.findIndex((el) => el.key == section);

      gsap.to(window, {
        duration: 0.00001,
        scrollTo: this.sectionsSteps[sectionId].pointer,
      });
    },
    SwipeWeb() {
      this.webPhase = (this.webPhase + 1) % 3;
    },
    SwipeDesign() {
      this.desPhase = (this.desPhase + 1) % 2;
    },

    OnSplashClose() {
      if (!this.splashExitRunning) {
        if (this.blackLoaderCtn) {
          this.blackLoaderCtn.removeEventListener(
            "scroll",
            this.listenLoaderScroll
          );
          this.blackLoaderCtn.removeEventListener(
            "touchmove",
            this.listenLoaderScroll
          );
        }

        // this.splashOpen = false;
        this.splashExitRunning = true;
        this.splashAnimation.play(0);
      }
    },

    /* -------------------------------------------------------------------------- */
    /*                                DESIGN MODAL                                */
    /* -------------------------------------------------------------------------- */

    openDesignModal() {
      this.isDesignClicked = true;
      this.isDesignHover = false;

      /* ------------------------- orbit circle animation ------------------------- */
      const sfera = document.getElementById("orbits-des");
      // console.log("client height", window.innerHeight);
      // console.log("client bound", sfera.getBoundingClientRect().top);
      // console.log(
      //   "client sub",
      //   window.innerHeight - sfera.getBoundingClientRect().top
      // );
      const rect = sfera.getBoundingClientRect();
      if (rect.top > 0) {
        this.modalCircleCoordinates = {
          bottom: window.innerHeight - rect.top + "px",
          left: rect.left + "px",
        };
      } else {
        this.modalCircleCoordinates = {
          bottom: window.innerHeight / 2 + "px",
          left: window.innerWidth / 2 + "px",
        };
      }
      /* ------------------------------ modal display rules ------------------------------ */
      document.querySelector("body").style.overflowY = "hidden";
      // document.querySelector("body").style.position = "fixed";
      if (!this.isDesktop) {
        document.querySelector(".servizi-mobile-btn-container").style.display =
          "none";
      }

      // this.scrollPosition = window.pageYOffset;
      // document.querySelector("body").style.top = `-${this.scrollPosition}px`;
      // document.querySelector("body").style.height = "100vh";

      /* ------------------------------ actual modal ------------------------------ */
      setTimeout(() => {
        this.isDesignOpen = true;
      }, 500);
    },

    /* -------------------------------------------------------------------------- */
    /*                                  WEB MODAL                                 */
    /* -------------------------------------------------------------------------- */

    openWebModal() {
      this.isWebClicked = true;
      this.isWebHover = false;

      /* ------------------------- orbit circle animation ------------------------- */
      const sfera = document.getElementById("orbits-web");

      const rect = sfera.getBoundingClientRect();
      if (rect.top > 0) {
        this.modalCircleCoordinates = {
          bottom: window.innerHeight - rect.top + "px",
          left: rect.left + "px",
        };
      } else {
        this.modalCircleCoordinates = {
          bottom: window.innerHeight / 2 + "px",
          left: window.innerWidth / 2 + "px",
        };
      }
      /* ------------------------------ modal display rules ------------------------------ */
      document.querySelector("body").style.overflowY = "hidden";
      // document.querySelector("body").style.position = "fixed";
      if (!this.isDesktop) {
        document.querySelector(".servizi-mobile-btn-container").style.display =
          "none";
      }
      // this.scrollPosition = window.pageYOffset;
      // document.querySelector("body").style.top = `-${this.scrollPosition}px`;
      // document.querySelector("body").style.height = "100vh";

      /* ------------------------------ actual modal ------------------------------ */
      setTimeout(() => {
        this.isWebOpen = true;
      }, 500);
    },

    /* -------------------------------------------------------------------------- */
    /*                                 CLOSE MODAL                                */
    /* -------------------------------------------------------------------------- */

    async closeModal() {
      this.isDesignOpen = false;
      this.isWebOpen = false;

      // await this.$nextTick();
      setTimeout(() => {
        this.isClosingModalAnim = true;

        document.querySelector("body").style.overflowY = "scroll";
        // document.querySelector("body").style.position = "initial";
        if (!this.isDesktop) {
          document.querySelector(
            ".servizi-mobile-btn-container"
          ).style.display = "inline";
        }

        setTimeout(() => {
          this.isClosingModalAnim = false;
          this.isDesignClicked = false;
          this.isWebClicked = false;
        }, 400);
      }, 10);

      // document.querySelector("body").style.removeProperty("top");
      // document.querySelector("body").style.removeProperty("height");
      // window.scrollTo(0, this.scrollPosition);
    },

    openForm() {
      this.$router.push("/contacts");
      // document.querySelector("body").style.position = "fixed";
    },

    openDunaLanding() {
      window.open("https://duna.endor.studio", "_blank");
    },

    // closeForm() {
    //   this.isFormOpen = false;
    //   document.querySelector("body").style.overflowY = "scroll";
    //   // document.querySelector("body").style.position = "initial";
    // },
  },
};
</script>
